import React, { useState, useEffect } from 'react';

export const LoadingScreen = ({ onLoadComplete }) => {
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(timer);
          setTimeout(() => {
            setIsVisible(false);
            if (onLoadComplete) onLoadComplete();
          }, 500);
          return 100;
        }
        return prev + 2;
      });
    }, 30);

    return () => clearInterval(timer);
  }, [onLoadComplete]);

  if (!isVisible) return null;

  return (
    <div
      className={`fixed inset-0 z-[9999] bg-[#0A2235] flex flex-col items-center justify-center transition-opacity duration-500 ${
        progress >= 100 ? 'opacity-0' : 'opacity-100'
      }`}
      data-testid="loading-screen"
    >
      {/* Logo SVG */}
      <div className="mb-8 animate-pulse notranslate" translate="no">
        <svg className="h-24 md:h-32 w-auto" viewBox="0 0 600 200" xmlns="http://www.w3.org/2000/svg">
          <path d="M60 105 Q90 65 120 95 Q150 125 180 85 Q210 45 240 75" fill="none" stroke="#7ECFCF" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M60 125 Q90 85 120 115 Q150 145 180 105 Q210 65 240 95" fill="none" stroke="#2BBFBF" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"/>
          <text x="280" y="95" fontSize="54" fontWeight="500" fill="#FAFAF7" fontFamily="Georgia, 'Times New Roman', serif" letterSpacing="-0.5">Marea</text>
          <text x="281" y="145" fontSize="42" fontWeight="400" fill="#2BBFBF" fontFamily="Georgia, 'Times New Roman', serif" letterSpacing="0">Riviera</text>
          <text x="282" y="170" fontSize="13" fontWeight="400" fill="#FAFAF7" fontFamily="Arial, Helvetica, sans-serif" letterSpacing="4" opacity="0.6">REAL ESTATE INVESTMENT</text>
        </svg>
      </div>

      {/* Loading bar */}
      <div className="w-64 md:w-80 h-1 bg-[#FAFAF7]/10 overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-[#2BBFBF] to-[#7ECFCF] transition-all duration-100"
          style={{ width: `${progress}%` }}
        />
      </div>

      {/* Loading text */}
      <p className="mt-4 text-[#FAFAF7]/60 text-sm font-inter tracking-widest">
        {progress < 100 ? 'CARGANDO...' : 'BIENVENIDO'}
      </p>

      {/* Wave animation */}
      <div className="absolute bottom-0 left-0 right-0 h-40 overflow-hidden">
        <svg 
          className="absolute bottom-0 animate-wave" 
          viewBox="0 0 2880 120" 
          preserveAspectRatio="none"
          style={{ height: '70px', width: '200%' }}
        >
          <path 
            d="M0,60 C240,120 480,0 720,60 C960,120 1200,0 1440,60 C1680,120 1920,0 2160,60 C2400,120 2640,0 2880,60 L2880,120 L0,120 Z" 
            fill="#2BBFBF"
            fillOpacity="0.35"
          />
        </svg>
        <svg 
          className="absolute bottom-0 animate-wave-slow" 
          viewBox="0 0 2880 120" 
          preserveAspectRatio="none"
          style={{ height: '55px', width: '200%' }}
        >
          <path 
            d="M0,80 C240,20 480,100 720,40 C960,100 1200,20 1440,80 C1680,20 1920,100 2160,40 C2400,100 2640,20 2880,80 L2880,120 L0,120 Z" 
            fill="#7ECFCF"
            fillOpacity="0.25"
          />
        </svg>
        <svg 
          className="absolute bottom-0 animate-wave-fast" 
          viewBox="0 0 2880 120" 
          preserveAspectRatio="none"
          style={{ height: '45px', width: '200%' }}
        >
          <path 
            d="M0,40 C360,100 720,20 1080,80 C1440,20 1800,100 2160,40 C2520,100 2880,20 2880,40 L2880,120 L0,120 Z" 
            fill="#D4EDE8"
            fillOpacity="0.15"
          />
        </svg>
      </div>

      <style jsx>{`
        @keyframes wave {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes wave-reverse {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
        .animate-wave {
          animation: wave 6s linear infinite;
        }
        .animate-wave-slow {
          animation: wave-reverse 8s linear infinite;
        }
        .animate-wave-fast {
          animation: wave 4s linear infinite;
        }
      `}</style>
    </div>
  );
};
